import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/sysUser'

/** 获取人员下拉选项 */
export const getSysUserOptions = () => {
  return axios.get(`${rootApi}/getIsolatedOptions`)
}
/** 获取质量负责人列表 */
export const getqualityList = () => {
  return axios.get(`/api_v2/organization/admin/qualityList`)
}
/** 指派检验任务 */
export const taskAssign = (params) => {
  return axios.post(`/api_v2/inspect/task/assign`,params,{dataType: 'json'})
}
/** 指派检验人员 */
export const setInspector = (params) => {
  return axios.post(`/api_v2/production/workOrder/setInspector`,params,)
}
/** 检查者签卡 */
export const signatureInspector = (params) => {
  return axios.post(`/api_v2/production/workOrder/signatureInspector`,params,)
}
/** 生成领料单二维码 */
export const createSupplementaryMaterialOrder = (params) => {
  return axios.post(`/api_v2/production/supplementaryMaterialOrder/createSupplementaryMaterialOrder`,params,{dataType: 'json'})
}